export default __webpack_public_path__ + "static/media/people.1b420b86.jpg";